module.exports = __webpack_public_path__ + "img/fitfi.15e12cbc.svg";